import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Icon from "@mdi/react";
import { mdiLock } from "@mdi/js";
import { login } from "../store/authSlice";

const KEY_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

function generateSecretKey(length = 41) {
  const randomValues = new Uint32Array(length);
  window.crypto.getRandomValues(randomValues);
  return Array.from(randomValues, (value) => KEY_CHARS[value % KEY_CHARS.length]).join("");
}

function SecretKey() {
  const [secretKey, setSecretKey] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    setSecretKey(generateSecretKey());
  };

  const handleConfirm = async () => {
    setSubmitting(true);
    setError("");

    const username = sessionStorage.getItem("register_username");
    const password = sessionStorage.getItem("register_password");
    const telegram = sessionStorage.getItem("register_telegram");
    const jabber = sessionStorage.getItem("register_jabber");
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    try {
      const res = await fetch(`${backendUrl}/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password, telegram, jabber, secret_key: secretKey }),
      });
      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setError(data?.error || "Registration failed. Please try again.");
        setSubmitting(false);
        return;
      }

      dispatch(login({ token: data.token, username: data.username, registered_at: data.registered_at }));
      sessionStorage.removeItem("register_username");
      sessionStorage.removeItem("register_password");
      sessionStorage.removeItem("register_telegram");
      sessionStorage.removeItem("register_jabber");

      navigate("/wallet");
    } catch (err) {
      setError("Network error. Please try again.");
      setSubmitting(false);
    }
  };

  return (
    <div className="page">
      <div>
        <div className="container wd-md-50p wd-sm-100p">
          <div className="wrap-login100 p-0">
            <div className="card-body">
              {secretKey === null ? (
                <form className="validate-form" method="POST" onSubmit={handleSubmit}>
                  <div className="d-flex flex-row justify-content-center align-items-center mb-5">
                    <div className="fs-50">
                      <Icon path={mdiLock} size={2.2} />
                    </div>
                    <div className="fs-18 ms-3">
                      Generate a secret-key and save it to yourself.
                      <br />
                      You will need it to login.
                    </div>
                  </div>
                  <div className="container-login100-form-btn">
                    <button type="submit" className="login100-form-btn btn-primary">
                      Generate secret-key
                    </button>
                  </div>
                </form>
              ) : (
                <div className="validate-form">
                  <div className="d-flex flex-row justify-content-center align-items-center mb-5">
                    <div className="fs-50">
                      <Icon path={mdiLock} size={2.2} />
                    </div>
                    <div className="fs-18 ms-3">
                      Your secret-key:
                      <p className="mt-3 mb-3">
                        <b>{secretKey}</b>
                      </p>
                      Save it to yourself. You will need it to login.
                    </div>
                  </div>
                  {error && (
                    <div className="invalid-feedback" style={{ display: "block", width: "100%", marginTop: "0.25rem", fontSize: "87.5%", color: "#d12c47", textAlign: "center" }}>
                      <strong>{error}</strong>
                    </div>
                  )}
                  <div className="container-login100-form-btn" style={{ position: "relative" }}>
                    {submitting && (
                      <div style={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "rgba(255,255,255,0.6)",
                        borderRadius: "4px",
                        zIndex: 10,
                      }}>
                        <div style={{
                          width: "22px",
                          height: "22px",
                          border: "3px solid #ccc",
                          borderTopColor: "#333",
                          borderRadius: "50%",
                          animation: "spin 0.7s linear infinite",
                        }} />
                      </div>
                    )}
                    <button type="button" className="login100-form-btn btn-primary" onClick={handleConfirm} disabled={submitting}>
                      I save the secret-key
                    </button>
                  </div>
                  <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SecretKey;
